/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('global/UI/all',[
    './Core',
    './BackToTop',
    './Modal',
    './Navigation',
    './Setup'
], function (UI, BackToTop, Modal, Navigation, Setup) {
    UI.BackToTop = BackToTop;
    UI.Modal = Modal;
    UI.Navigation = Navigation;
    UI.Setup = Setup;

    BackToTop.init();

    return UI;
});

